import React from "react";
var __jsx = React.createElement;
var PaymentRowShimmer = function PaymentRowShimmer() {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex w-full items-center gap-3 rounded-lg border border-solid border-[#e0e0e0] bg-white py-[19px] px-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-5 w-5 shrink-0 rounded-full bg-gray-200"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 flex-col gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-2/3 rounded bg-gray-200"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-3 w-1/2 rounded bg-gray-200"
  })));
};
var BnplGroupShimmer = function BnplGroupShimmer() {
  return /*#__PURE__*/React.createElement("div", {
    className: "overflow-hidden rounded-lg border border-solid border-[#e0e0e0]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start gap-3 border-b border-solid border-[#e0e0e0] bg-white p-4 py-[19.5px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex min-w-0 flex-1 flex-col gap-2 pl-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-1/2 rounded bg-gray-200"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-3 w-2/3 rounded bg-gray-200"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col bg-white pb-2"
  }, [0, 1].map(function (idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx
    }, idx > 0 && /*#__PURE__*/React.createElement("div", {
      className: "h-px w-full bg-[#e6e9ef]"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex w-full items-center gap-3 p-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-5 w-5 shrink-0 rounded-full bg-gray-200"
    }), /*#__PURE__*/React.createElement("div", {
      className: "h-5 w-[66px] shrink-0 rounded bg-gray-200"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-4 w-3/4 rounded bg-gray-200"
    }))));
  })));
};
var PreCheckoutOptionsShimmer = function PreCheckoutOptionsShimmer() {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 animate-pulse"
  }, /*#__PURE__*/React.createElement(PaymentRowShimmer, null), /*#__PURE__*/React.createElement(PaymentRowShimmer, null), /*#__PURE__*/React.createElement(BnplGroupShimmer, null), /*#__PURE__*/React.createElement(PaymentRowShimmer, null));
};
export default PreCheckoutOptionsShimmer;